import { createContext } from "react";

import { FilterCriteria } from "../../../../models";

export const FilterContext = createContext<FilterCriteria[] | undefined>([]);
